import { render } from "./PublicKoTatou.vue?vue&type=template&id=55b593c7&scoped=true"
import script from "./PublicKoTatou.vue?vue&type=script&lang=js"
export * from "./PublicKoTatou.vue?vue&type=script&lang=js"

import "../assets/styles/public-ko-tatou.css?vue&type=style&index=0&id=55b593c7&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b593c7"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QInput,QBtn});
